export enum variants {
  Border = 'border',
  Elevated = 'elevated',
  Overcard = 'overcard',
}
